// extracted by mini-css-extract-plugin
module.exports = {"filters":"PaginatedTable_filters__32IPv","filterByCol":"PaginatedTable_filterByCol__3VeMi","filterByProduct":"PaginatedTable_filterByProduct__3KWDb"};